/** Shared sx for property strategy dashboard pages (CenterPage). */

const ON_DARK = 'html[data-color-mode="dark"] &'

export const strategyMetricRowSx = {
  mt: '5px',
  mb: '5px',
}

export const strategyMutedTextSx = {
  color: '#9198a8',
  [ON_DARK]: { color: 'rgba(255, 255, 255, 0.68)' },
}

export const strategyCenterTextSx = {
  textAlign: 'center',
}

export const strategyOrderDrawerPaperSx = {
  bgcolor: '#253152',
  p: '15px',
}

export const strategyOrderDrawerCloseWrapSx = {
  ml: '20px',
}

export const strategyOrderResetBtnWrapSx = {
  ml: 0,
}

export const strategyOrderSaveBtnSx = {
  bgcolor: '#4290ff',
  color: 'white',
  boxShadow: 'none',
}

export const strategyOrderSaveLabelSx = {
  fontWeight: 600,
}

export const strategyOrderFormWhiteSx = {
  color: 'white',
}

export const strategyOrderFlexSpacerSx = {
  flex: 1,
}

export const strategyOrderCloseIconSx = {
  color: 'white',
}

export const strategyTourStepTitleSx = {
  textAlign: 'center',
}

export const strategyWhiteTextSx = {
  color: 'white',
}

export const strategyMutedDividerSx = {
  bgcolor: '#9198a8',
}

export const strategyIconGapSx = {
  mr: '3px',
}

export const strategySectionLabelSx = {
  color: '#9198a8',
  mb: '20px',
  [ON_DARK]: { color: 'rgba(255, 255, 255, 0.68)' },
}

export const strategySectionSpacerSx = {
  mb: '10px',
}

export const strategyBlockSpacerSx = {
  mb: '15px',
  mt: '15px',
}

export const strategyDarkTextSx = {
  color: '#070919',
  [ON_DARK]: { color: 'rgba(255, 255, 255, 0.87)' },
}

export const strategyUnderlineSx = {
  textDecoration: 'underline',
}

/** Tooltip glossary link (blue + underline). */
export const strategyTooltipLinkSx = {
  color: '#4191ff',
  textDecoration: 'underline',
}

export const strategyTopSpacerSx = {
  mt: '25px',
}

export const strategyFullHeightSx = {
  height: '100%',
}

export const strategyMetricRowFlexSx = {
  display: 'flex',
  alignItems: 'center',
  pt: '0.75rem',
  pb: '0.75rem',
  pl: '1.25rem',
  pr: '1.25rem',
  mb: '5px',
  mt: '5px',
  bgcolor: '#fff',
  [ON_DARK]: {
    bgcolor: '#1e1e1e !important',
    color: 'rgba(255, 255, 255, 0.87)',
  },
}

export const strategyTableRowSx = {
  display: 'flex',
  alignItems: 'center',
  pt: '0.75rem',
  pb: '0.75rem',
  pl: '1.25rem',
  pr: '1.25rem',
  mb: 0,
  bgcolor: '#fff',
  [ON_DARK]: {
    bgcolor: '#1e1e1e !important',
    color: 'rgba(255, 255, 255, 0.87)',
  },
}

export const strategyFieldLabelSx = {
  color: '#4f5062',
  pb: '0.25rem',
  [ON_DARK]: { color: 'rgba(255, 255, 255, 0.68)' },
}

export const strategyLinkBlueSx = {
  color: '#4191ff',
}

export const strategyFlexCenterSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#070919',
  [ON_DARK]: { color: 'rgba(255, 255, 255, 0.87)' },
}

export const strategyFlexPadSx = {
  display: 'flex',
  p: '0.25rem',
  alignItems: 'center',
}

export const strategyBadgeIconSx = {
  height: 20,
  width: 'auto',
  lineHeight: '20px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  p: 0,
}

const strategyMetricDotBaseSx = {
  display: 'inline-block',
  pt: 0,
  pb: 0,
  pl: '0.7em',
  pr: '0.7em',
  fontSize: '70%',
  fontWeight: 700,
  lineHeight: '21px',
  textAlign: 'center',
  whiteSpace: 'nowrap',
  verticalAlign: 'baseline',
  borderRadius: '100%',
  textTransform: 'uppercase',
  height: 10,
  color: '#fff',
  textIndent: '-999rem',
  width: 10,
  p: 0,
  boxShadow: '0 0 0 2px #fff',
  mr: '0.5rem',
  [ON_DARK]: { boxShadow: '0 0 0 2px #1e1e1e' },
}

export const strategyMetricDotGreenSx = {
  ...strategyMetricDotBaseSx,
  bgcolor: '#1bc943',
}

export const strategyMetricDotRedSx = {
  ...strategyMetricDotBaseSx,
  bgcolor: '#f83245',
}

export const strategyMetricDotBlueSx = {
  ...strategyMetricDotBaseSx,
  bgcolor: '#368cff',
}

export const strategyCardTitleSx = {
  fontSize: 30,
  fontWeight: 600,
}

export const strategyFullWidthSx = {
  width: '100%',
}

export const strategyFullWidthHiddenSx = {
  width: '100%',
  overflow: 'hidden',
}

export const strategyMaxHeight440Sx = {
  maxHeight: 440,
}

export const strategyVerticalSpacerSx = {
  mt: '1rem',
  mb: '1rem',
}

export const strategyFooterNoteSx = {
  color: '#fff',
  mt: '1rem',
}

export const strategyFlexCenterOnlySx = {
  display: 'flex',
  justifyContent: 'center',
}

/** Plain style objects for third-party components (FontAwesome, etc.). */
export const strategyIconGapStyle = { marginRight: 3 }
export const strategyIconGap5Style = { marginRight: 5 }
export const strategyIconGap10Style = { marginRight: 10 }
export const strategyIconGap20Style = { marginRight: 20 }
export const strategyAddIconGapStyle = { marginRight: 10 }

export const strategyPad5Sx = { p: '5px' }
export const strategyPagePadSx = { p: '25px' }
export const strategyMinSelectSx = { width: '100%', minWidth: 150 }
export const strategyAddCompBtnSx = { bgcolor: '#1cc943', color: 'white' }
export const strategyIconBlueBgSx = { bgcolor: '#4191ff' }
export const strategyIconSize40Sx = { fontSize: 40 }
export const strategyMutedGraySx = {
  color: '#bbbbbb',
  [ON_DARK]: { color: 'rgba(255, 255, 255, 0.55)' },
}
export const strategyFlexGrowSx = { flex: 1 }
export const strategyFontSemiboldSx = { fontWeight: 600 }
export const strategyMinHeight50Sx = { minHeight: 50 }
export const strategyFont16Sx = { fontSize: 16 }
export const strategyBorderMutedSx = { borderColor: '#f4f5fd' }
export const strategyFullHeight100Sx = { height: '100%' }
export const strategyFlexCenterRowSx = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
}
export const strategyMetricGrayBgSx = {
  bgcolor: '#eff2f5',
  borderRadius: 0,
  [ON_DARK]: { bgcolor: '#2a2a2a' },
}
export const strategyPositionCloseSx = {
  position: 'absolute',
  top: 5,
  right: 10,
}
export const strategyWhiteBlueChipSx = {
  color: 'white',
  bgcolor: '#368CFF',
  pl: '5px',
  pr: '5px',
}
export const strategyFlexSpaceBetweenSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}
export const strategySubtitleMutedSx = {
  mb: '1rem',
  color: 'rgba(59, 62, 102, 0.5)',
  textAlign: 'center',
  [ON_DARK]: { color: 'rgba(255, 255, 255, 0.68)' },
}
export const strategyTextMuted802Sx = {
  color: 'rgba(59, 62, 102, 0.8)',
  [ON_DARK]: { color: 'rgba(255, 255, 255, 0.68)' },
}
export const strategyMarginTop10Sx = { mt: '10px' }
export const strategyMarginTop35Sx = { mt: '35px' }
export const strategyMarginBottom25Sx = { mb: '25px' }
export const strategyPadVert15Sx = { pt: '15px', pb: '15px' }
export const strategyTransparentCenterSx = {
  textAlign: 'center',
  bgcolor: 'transparent',
}
export const strategyTableRowLastSx = {
  '&:last-child td, &:last-child th': { border: 0 },
}
export const strategyMarginBottom5Sx = { mb: '5px' }
export const strategyHighlightBlueSx = {
  bgcolor: '#cfe1fa',
  color: '#008aff',
}
export const strategyFlexSelfCenterSx = { display: 'flex', alignSelf: 'center' }

export const strategySummaryInsetSx = { mx: '-10px' }

export const strategySummaryBandSx = {
  p: '1rem',
  bgcolor: '#f8f9ff',
  borderRadius: '0.29rem',
  [ON_DARK]: {
    bgcolor: '#2a2a2a',
    color: 'rgba(255, 255, 255, 0.87)',
  },
}

/** Muted value next to a bold label (Asking Price, ARV, etc.). */
export const strategyMutedValueSx = {
  color: 'rgba(7, 9, 25, 0.5)',
  [ON_DARK]: { color: 'rgba(255, 255, 255, 0.68)' },
}

export const strategyWhiteSurfaceSx = {
  backgroundColor: '#fff',
  [ON_DARK]: {
    backgroundColor: '#2a2a2a',
    color: 'rgba(255, 255, 255, 0.87)',
  },
}

export const strategyDescriptionTextSx = {
  color: 'rgba(59, 62, 102, 0.5)',
  [ON_DARK]: { color: 'rgba(255, 255, 255, 0.68)' },
}

export const strategySemiboldMb10Sx = { fontWeight: 600, mb: '10px' }

export const strategySemiboldMb20Sx = { fontWeight: 600, mb: '20px' }

export const strategyIconPr5Sx = { pr: '5px' }

export const strategyMarginTop30Sx = { mt: '30px' }

export const strategyFullSizeSx = { height: '100%', width: '100%' }

export const strategyBoxShadowNoneSx = { boxShadow: 'none' }

export const strategyOverflowScrollSx = { overflow: 'scroll' }

/** Horizontal Unit 1 / Unit 2 tabs — track full width, no selected grey chip. */
export const unitTabsListSx = {
  display: 'flex',
  flexWrap: 'nowrap',
  width: '100%',
  maxWidth: '100%',
  overflowX: 'auto',
  position: 'relative',
  zIndex: 4,
  p: 0,
  '& > .MuiListItem-root': {
    width: 'auto',
    flex: '0 0 auto',
    maxWidth: 'none',
    p: 0,
    m: 0,
    background: 'transparent',
    backgroundColor: 'transparent',
    borderRadius: 0,
  },
  '& > .MuiListItem-root + .MuiListItem-root': {
    ml: '2rem',
  },
  '& .MuiListItem-root.MuiListItem-button, & .MuiListItemButton-root': {
    color: '#a6a6b9',
    position: 'relative',
    transition: 'all 0.2s ease-in-out',
    padding: '0.75rem 0 1rem',
    background: 'transparent',
    backgroundColor: 'transparent',
    width: 'auto',
    minHeight: 48,
    margin: 0,
    borderRadius: 0,
    alignItems: 'center',
    boxSizing: 'border-box',
    flex: '0 0 auto',
    '&:hover': {
      color: '#000',
      background: 'transparent',
      backgroundColor: 'transparent',
    },
    [ON_DARK]: {
      '&:hover': {
        color: 'rgba(255, 255, 255, 0.95)',
        background: 'transparent',
        backgroundColor: 'transparent',
      },
    },
    '&.Mui-selected': {
      color: '#368cff',
      fontWeight: 700,
      background: 'transparent',
      backgroundColor: 'transparent',
      '&:hover': {
        color: '#368cff',
        background: 'transparent',
        backgroundColor: 'transparent',
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        left: 0,
        bottom: 0,
        width: '100%',
        height: 3,
        borderRadius: '0.75rem',
        background: '#368cff',
        zIndex: 8,
      },
    },
  },
  '&::after': {
    background: '#f4f5fd',
    height: 3,
    borderRadius: '0.75rem',
    display: 'block',
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    content: '""',
    zIndex: 5,
  },
  [`${ON_DARK}::after`]: {
    background: 'rgba(255, 255, 255, 0.12)',
  },
}

export const strategyDrawerLegendSx = { textAlign: 'center', mr: '20px' }

export const strategyErrorTextSx = { color: 'red', fontSize: 13 }

export const strategyMargin20VerticalSx = { mt: '20px', mb: '20px' }

export const strategyMarginTop12Sx = { mt: '12px' }

export const strategyAvatarBlueLargeSx = { fontSize: 56, color: '#008bff' }

export const strategyMutedMetaSx = {
  color: '#a5a8a9',
  [ON_DARK]: { color: 'rgba(255, 255, 255, 0.55)' },
}

export const strategyCardPad20Sx = { p: '20px' }

export const strategyFlexAutoTopSx = { mt: 'auto' }

export const strategyCardBodyPadSx = {
  pl: '1.5rem',
  pr: '1.5rem',
  pb: '1.5rem',
  pt: '0.5rem',
}

export const strategyMarginBottom10Sx = { mb: '10px' }

export const strategyMarginTop25Sx = { mt: '25px' }

export const strategySubtitleCenterSx = {
  mb: '1rem',
  color: 'rgba(59, 62, 102, 0.5)',
  textAlign: 'center',
  [ON_DARK]: { color: 'rgba(255, 255, 255, 0.68)' },
}

export const strategyUppercaseMetaSx = {
  display: 'block',
  textTransform: 'uppercase',
  mt: '0.25rem',
}

export const strategyTableCellRightSx = {
  fontSize: 14,
  textAlign: 'right',
  bgcolor: '#e8ecef',
  p: '5px',
  [ON_DARK]: {
    bgcolor: '#2a2a2a',
    color: 'rgba(255, 255, 255, 0.87)',
  },
}

export const strategyMutedPadXSx = {
  px: '10px',
  color: 'rgba(59, 62, 102, 0.8)',
  [ON_DARK]: { color: 'rgba(255, 255, 255, 0.68)' },
}

export const strategyMarginRight10Sx = { mr: '10px' }

export const strategyPad10Sx = { p: '10px' }

export const strategyMarginTopBottom10Sx = { mt: '10px', mb: '10px' }

export const strategyPadBottom20Sx = { pb: '20px' }

export const strategyCompCardSx = {
  height: 325,
  bgcolor: 'transparent',
  m: '1px',
}

export const strategyCompImgSx = {
  maxHeight: 325,
  height: 'auto',
  width: 'auto',
  borderBottomRightRadius: '0px',
  objectFit: 'contain',
}

export const strategyCompImgFluidSx = {
  maxHeight: 325,
  height: 'auto',
  borderBottomRightRadius: '0px',
  objectFit: 'contain',
}

export const strategyCardPad15Sx = { p: '1.5rem' }

export const strategyLinkBoldBlueSx = { fontWeight: 700, color: '#4191ff' }

export const strategyLinkUnderlineBlueSx = {
  color: '#4191ff',
  textDecoration: 'underline',
}

export const strategyFlexFullWidthSx = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
}

export const strategyItalicMutedSx = {
  color: '#9198a8',
  fontSize: '0.85rem',
  fontStyle: 'italic',
  [ON_DARK]: { color: 'rgba(255, 255, 255, 0.68)' },
}

export const strategyFixedBottomBarSx = {
  position: 'fixed',
  bottom: '20px',
  width: '75%',
  zIndex: 1100,
}

export const strategySemiboldPullUpSx = { fontWeight: 600, mb: '-10px' }

export const strategyAbsTopRight10Sx = {
  position: 'absolute',
  top: 10,
  right: 10,
}

export const strategyRelPosSx = { position: 'relative' }

export const strategyIconSize70Sx = { height: 70, width: 70 }

export const strategyFormColumnScrollSx = {
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
}

export const strategyRelPosStyle = { position: 'relative' }

export const strategyIconGap2Style = { marginRight: 2 }

export const strategyMarginTop5Sx = { mt: '5px' }

export const strategyMarginBottomNeg30Sx = { mb: '-30px' }

export const strategyWidth400Sx = { width: 400 }

export const strategyWhiteSpaceNormalSx = { whiteSpace: 'normal' }

export const strategyTextRightSx = { textAlign: 'right' }

export const strategyPad25Sx = { p: '25px' }

export const strategyPad0Sx = { p: 0 }

export const strategyHeight500Sx = { height: 500 }

export const strategyMargin10Sx = { m: '10px' }

export const strategyInlineFlexSx = { display: 'inline-flex' }

export const strategyPadBottom0Sx = { pb: '0px' }

export const strategyDangerChipSx = { bgcolor: '#f83145', color: 'white' }

/** Pale danger icon well on delete dialogs. */
export const deleteDialogIconBlobSx = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: 0,
  backgroundColor: '#ffe6ea !important',
  height: '130px !important',
  width: '130px !important',
  lineHeight: '130px !important',
  p: 0,
  borderRadius: '50%',
  color: '#f83245',
  m: 0,
  [ON_DARK]: {
    backgroundColor: 'rgba(248, 50, 69, 0.18) !important',
    color: '#ff6b7a',
  },
}

export const deleteDialogConfirmTextSx = {
  mb: 0,
  color: '#a6a6b9',
  fontSize: '1.15rem !important',
  [ON_DARK]: {
    color: 'rgba(255, 255, 255, 0.82)',
    '& .MuiFormControlLabel-label': {
      color: 'rgba(255, 255, 255, 0.82)',
    },
    '& .MuiCheckbox-root': {
      color: 'rgba(255, 255, 255, 0.78)',
    },
    '& .MuiCheckbox-root.Mui-checked': {
      color: '#90caf9',
    },
  },
}

export const deleteDialogDangerBtnSx = {
  bgcolor: '#f83245',
  color: '#fff',
  '&:hover': { bgcolor: '#d92a3b', color: '#fff' },
  [ON_DARK]: {
    bgcolor: '#f83245',
    color: '#fff !important',
    '&.MuiButton-contained.Mui-disabled': {
      backgroundColor: 'rgba(248, 50, 69, 0.32) !important',
      border: '1px solid rgba(248, 50, 69, 0.45)',
      color: 'rgba(255, 255, 255, 0.55) !important',
    },
  },
}

export const strategyFont16SemiboldSx = { fontSize: 16, fontWeight: 600 }

export const strategyScrollXTouchSx = {
  width: '100%',
  maxWidth: '100%',
  minWidth: 0,
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
}

export const strategyPadBottom20FullSx = { pb: '20px', width: '100%' }

export const strategyWhiteSmallSx = { color: 'white', fontSize: 'small' }

export const strategyCircleGreenAvatarSx = {
  overflow: 'hidden',
  height: 40,
  width: 40,
  lineHeight: '40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  p: 0,
  bgcolor: '#f2f2f6',
  [ON_DARK]: { bgcolor: '#2a2a2a' },
  textAlign: 'center',
  fontWeight: 700,
  color: '#1bc943',
}

export const strategyFlexPadMin50Sx = {
  display: 'flex',
  p: '0.25rem',
  alignItems: 'center',
  minHeight: 50,
}

export const strategyTransparentRelCenterSx = {
  textAlign: 'center',
  bgcolor: 'transparent',
  position: 'relative',
}

export const strategyAbsTopRightPinkSx = {
  position: 'absolute',
  top: 10,
  right: 10,
  bgcolor: '#FA7A87',
}

export const strategyNavyBgSx = {
  bgcolor: '#070919',
  [ON_DARK]: {
    bgcolor: '#1e1e1e',
    opacity: '0.78 !important',
  },
}

export const calcDialogPaperSx = {
  borderRadius: '0.65rem !important',
  border: 0,
  backgroundColor: '#fff',
  p: '1rem',
  '@media (min-width: 1440px)': { p: 0 },
  [ON_DARK]: {
    backgroundColor: '#1e1e1e !important',
    p: 0,
  },
}

export const clampLinearProgressValue = (value) => {
  const n = Number(value)
  if (!Number.isFinite(n)) return 0
  return Math.min(100, Math.max(0, n))
}

export const strategyMaxWidth720Style = { maxWidth: 720 }

export const strategyCarouselCardSx = {
  bgcolor: 'white',
  m: '1px',
  [ON_DARK]: { bgcolor: '#1e1e1e' },
}

export const strategyCarouselSlideSx = { height: 500 }

export const strategyHeroImageSx = {
  maxHeight: 500,
  height: 'auto',
  borderBottomRightRadius: '0px',
  objectFit: 'fill',
}

export const strategyPrimaryBadgeSx = {
  position: 'absolute',
  bottom: 10,
  left: 10,
  color: 'white',
  fontWeight: 600,
  bgcolor: '#ffaf00',
}

export const strategyAbsBottomLeftSx = {
  position: 'absolute',
  bottom: 10,
  left: 10,
}

export const strategySectionRowSx = {
  display: 'flex',
  justifyContent: 'space-between',
  pt: '0.5rem',
  pb: '0.5rem',
}

export const strategySectionRowLooseSx = {
  display: 'flex',
  justifyContent: 'space-between',
}

export const strategyLabel16BoldSx = { fontSize: 16, fontWeight: 700 }

export const strategySummaryInsetPadSx = {
  mx: '-10px',
  p: '1rem',
}

export const strategyCardGraySx = {
  bgcolor: '#eff2f5',
  [ON_DARK]: { bgcolor: '#2a2a2a' },
}

export const strategyPad10ContentSx = { p: '10px' }

export const strategyNowrap13Sx = { whiteSpace: 'nowrap', fontSize: 13 }

export const strategyTinyAvatarSx = { bgcolor: '#2296F3', height: 15, width: 15 }

export const strategyTinyAvatarGreenSx = {
  bgcolor: '#46de64',
  height: 15,
  width: 15,
}

export const strategyTinyAvatarRedSx = {
  bgcolor: '#F05248',
  height: 15,
  width: 15,
}

export const strategyWhiteSmallIconSx = { color: 'white', fontSize: 'small' }

export const strategyMarginLeft5Sx = { ml: '5px' }

export const strategyLabel12BoldSx = { fontSize: 12, fontWeight: 700 }

export const strategyMarginBottom10StrSx = { mb: '10px' }

export const strategyIconMl10Style = { marginLeft: 10 }

export const strategyPadVert1RemSx = { pt: '1rem', pb: '1rem' }

export const strategyWidthFullRadius0Sx = { width: '100%', borderRadius: 0 }

export const strategyFullWidthMt30Sx = { width: '100%', mt: '30px' }

export const strategyBackdropWhiteSx = { color: '#fff', zIndex: 2000 }

export const strategyInlineFlexSpanSx = { display: 'inline-flex' }

export const strategyCompMetricsPadSx = { p: '10px' }

export const strategyCompCheckboxSx = {
  height: 20,
  width: 20,
  borderRadius: 0,
}

export const strategyCompAvatarSx = {
  height: 30,
  width: 30,
  color: '#fff',
}

export const strategyPrice26Sx = { fontSize: 26, fontWeight: 600 }

export const strategyNowrapMuted600Sx = {
  whiteSpace: 'nowrap',
  fontWeight: 600,
}

export const strategyNowrapLink600Sx = {
  whiteSpace: 'nowrap',
  color: '#008bff',
  fontWeight: 600,
}

export const strategyMarginBottomNeg30GridSx = { mb: '-30px' }

export const strategyMarginTop5GridSx = { mt: '5px' }

export const strategySliderWidthSx = { width: '88%', ml: '18px' }

export const strategyMarginTop10OnlySx = { mt: '10px' }

export const strategyPacemorbyCardSx = {
  borderRadius: 0,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}

export const strategyOverflowVisibleCardSx = {
  borderRadius: 0,
  height: 'auto',
  overflow: 'visible',
}

export const strategyBorderRadius0Sx = { borderRadius: 0 }

/** Secondary line under a strategy name (e.g. "% Targets Met"). */
export const strategySelectMetaSx = {
  color: 'rgba(7, 9, 25, 0.5)',
  display: 'block',
  [ON_DARK]: {
    color: 'rgba(255, 255, 255, 0.68)',
  },
}
